package com.ijoin.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp
import com.ijoin.i18n.Strings
import com.ijoin.i18n.strings
import com.ijoin.ui.design.EventCardAccentDark
import com.ijoin.ui.design.EventCardAlert
import com.ijoin.ui.design.EventCardInputCorner
import com.ijoin.ui.design.EventCardOutline
import com.ijoin.ui.design.EventOutlineButton
import com.ijoin.ui.design.EventTextAction

@Composable
fun EventManagementButtons(
    onEditClick: () -> Unit,
    onDeleteClick: () -> Unit,
    isDeleting: Boolean,
    modifier: Modifier = Modifier,
    strings: Strings = strings(),
    accentColor: Color = EventCardAccentDark,
    outlineColor: Color = EventCardOutline,
    dangerColor: Color = EventCardAlert,
    shape: Shape = androidx.compose.foundation.shape.RoundedCornerShape(EventCardInputCorner)
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        EventOutlineButton(
            text = strings.edit,
            onClick = onEditClick,
            modifier = Modifier.height(36.dp),
            leadingIcon = Icons.Default.Edit
        )
        EventTextAction(
            text = strings.delete,
            onClick = onDeleteClick,
            enabled = !isDeleting,
            leadingIcon = Icons.Default.Delete,
            contentColor = dangerColor,
            isLoading = isDeleting
        )
    }
}
